import { FeedSortType } from './types/feed';

export function isFeedSortTypeValid(value: unknown): value is FeedSortType {
    return Object.values(FeedSortType).includes(value as FeedSortType);
}
